export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/mini-program-personal-qr-1eded9c89f805f86fdb16b3ee2a9c3f1.png";